var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.417 2.08331L9.37533 3.12498H4.16699V5.20831H5.20866V20.8333C5.20866 21.3773 5.40796 21.9319 5.8007 22.3246C6.19344 22.7173 6.74801 22.9166 7.29199 22.9166H17.7087C18.2526 22.9166 18.8072 22.7173 19.2 22.3246C19.5927 21.9319 19.792 21.3773 19.792 20.8333V5.20831H20.8337V3.12498H15.6253L14.5837 2.08331H10.417ZM7.29199 5.20831H17.7087V20.8333H7.29199V5.20831ZM9.37533 7.29165V18.75H11.4587V7.29165H9.37533ZM13.542 7.29165V18.75H15.6253V7.29165H13.542Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.1570fec15802b872dff2fad6dcd995f0.svg";
export { ForwardRef as ReactComponent };